import { render, staticRenderFns } from "./Venues.vue?vue&type=template&id=6df67204&scoped=true&"
import script from "./Venues.vue?vue&type=script&lang=ts&"
export * from "./Venues.vue?vue&type=script&lang=ts&"
import style0 from "./Venues.vue?vue&type=style&index=0&id=6df67204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df67204",
  null
  
)

export default component.exports